import {useEffect} from 'react';
import {config, filter} from 'helpers';

export function Title({children}: {children: React.ReactNode}) {
  useEffect(() => {
    window.document.title = filter([children, config.appName]).join(' - ');
  }, [children]);
  return null;
}
